import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  tone?: "light" | "dark";
}

export default function Breadcrumb({ items, tone = "light" }: BreadcrumbProps) {
  const base = tone === "dark" ? "text-background-50/60" : "text-foreground-500";
  const current = tone === "dark" ? "text-background-50" : "text-foreground-900";
  const hover = tone === "dark" ? "hover:text-accent-300" : "hover:text-accent-600";

  return (
    <nav aria-label="面包屑导航" className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-xs ${base}`}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link to={item.to} className={`${hover} transition-colors`}>
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? current : undefined}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-sm opacity-60" aria-hidden="true"></i>}
          </span>
        );
      })}
    </nav>
  );
}